// ignore-string-externalization

import React, { createContext, useContext } from 'react';
import type { fetchVideosData } from './videosFetcher';

export { fetchVideosData } from './videosFetcher';

type VideosData = NonNullable<Awaited<ReturnType<typeof fetchVideosData>>>;

type VideosContextValue = {
  videoCategories: VideosData['videoCategories'] | undefined;
  videos: VideosData['videos'] | undefined;
  videoGroups: VideosData['videoGroups'] | undefined;
  socialCard: VideosData['socialCard'] | undefined;
};

const VideosDataContext = createContext<VideosContextValue>({
  videoCategories: undefined,
  videos: undefined,
  videoGroups: undefined,
  socialCard: undefined,
});

export const VideosDataProvider = ({
  data,
  children,
}: {
  data: VideosData | null;
  children: React.ReactNode;
}) => (
  <VideosDataContext.Provider
    value={{
      videoCategories: data?.videoCategories,
      videos: data?.videos,
      videoGroups: data?.videoGroups,
      socialCard: data?.socialCard,
    }}
  >
    {children}
  </VideosDataContext.Provider>
);

export const useVideosData = () => useContext(VideosDataContext);
